import { render } from "./VisionThreeCharts.vue?vue&type=template&id=4bcd17b5"
import script from "./VisionThreeCharts.vue?vue&type=script&lang=js"
export * from "./VisionThreeCharts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__